<template>
  <!-- 签到 -->
  <div class="sign">
    <van-dialog :value="signInfo.showSignModal" title="" :showConfirmButton="false">
      <div class="sign-modal-conatiner">
        <van-icon name="clock" color="orange" size="50" />
        <div class="count-down-container">
          <van-count-down @finish="onCountDownFinish" :time="signInfo.time" />
        </div>
        <div class="sign-info">
          请在倒计时结束前点击签到按钮
        </div>
        <div @click="handle2Sign" class="sign-modal-btn">立即签到</div>
      </div>
      <div @click="closeSign" class="sign-close">
        <i class="iconfont icon-close"></i>
      </div>
    </van-dialog>

    <circle-btn v-if="signInfo.showSignBtn" @click.native="checkHasSign" class="sign-btn">签到</circle-btn>
  </div>
</template>

<script>
import {getattendance, getSignSet, signCheck} from '@/api'
export default {
  data() {
    return {
      id: this.$route.params.id
    }
  },
  computed: {
    /* user信息 */
    userInfo() {
      return this.$store.state.userInfo
    },
    signInfo() {
      return this.$store.state.activePlay.signInfo
    }
  },
  mounted() {
    this.checkHasSign()
  },
  methods: {
    checkHasSign() {
      /* 未登录的情况 */
      if (!this.userInfo.id) return
      const params = {
        id: this.id,
        type: 1,
        userId: this.userInfo.id
      }
      getattendance(params).then(res => {
        if (res.data) {
          /* 有签到，获取签到信息 */
          this.getSignInfo()
        } else {
          this.$store.commit('setSignInfo', {
            showSignBtn: false,
            showSignModal: false
          })
        }
      })
    },
    getSignInfo() {
      const params = {
        id: this.id,
        type: 1
      }
      getSignSet(params).then(res => {
        if (res.code === 0) {
          const {endTime} = res.data
          this.startTime = +new Date()
          this.endTime = +new Date(endTime.replace(/-/g, '/'))
          const time = parseInt(this.endTime - this.startTime)
          this.$store.commit('setSignInfo', {
            showSignBtn: true,
            showSignModal: true,
            time
          })
        }
      })
    },
    closeSign() {
      this.$store.commit('setSignInfo', {
        showSignModal: false
      })
    },
    onCountDownFinish() {
      this.$store.commit('setSignInfo', {
        showSignBtn: false,
        showSignModal: false
      })
    },
    handle2Sign() {
      const params = {
        objectId: this.id,
        objectType: 1,
        sourceFor: 2
      }
      signCheck(params).then(res => {
        if (res.code === 0) {
          this.$Toast.success('签到成功')
          this.$store.commit('setSignInfo', {
            showSignBtn: false,
            showSignModal: false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.sign-modal-conatiner {
  background-color: #fff;
  padding: 25px 10px;
  border-radius: 10px;
  text-align: center;
  .sign-info {
    color: #c0c4cc;
    font-size: 14px;
    padding: 20px 0;
  }
  .count-down-container {
    padding: 10px 0;
    div {
      font-size: 20px;
      color: orange;
    }
  }
  .sign-modal-btn {
    background: linear-gradient(#4465f3 0%, #4a86f6 100%);
    color: #fff;
    border-radius: 20px;
    padding: 10px 0;
  }
}

.sign-close {
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.32);
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 40px;
  margin: 10px auto 0;
}
.sign-btn {
  position: absolute;
  z-index: 96;
  right: 20px;
  bottom: 28%;
}
</style>
<style lang="scss">
.sign .van-dialog {
  background-color: transparent;
  .van-dialog__content {
    padding: 20px;
  }
}
</style>
